import { useContext } from "react";

import { ShellContext } from "@/components/shell/ShellProvider";

/** Access the shell UI state (sidebar / task panel / tree). Must be rendered
 *  under {@link ShellProvider} (mounted by AppShell). */
export function useShellState() {
  const ctx = useContext(ShellContext);
  if (!ctx) {
    throw new Error("useShellState must be used within a ShellProvider");
  }
  return ctx;
}
